import { Checkbox, Edit, Form, Select, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import RouterProvider from "@pankod/refine-react-router-v6";
import { useMemo } from "react";
import { ITransaction } from "types/transaction.interface";

export const QuestionEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<any>();

  const { queryResult } = useShow<ITransaction>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  const optionStatus = [
    { label: "Pending", value: "pending" },
    { label: "Resolved", value: "resolved" },
  ];

  const formItems = useMemo(() => {
    return [
      {
        type: "object",
        label: "User",
        name: "user",
        children: "email",
      },
      {
        label: "Full Name",
        name: "fullName",
      },
      {
        label: "Email Address",
        name: "emailAddress",
      },
      // {
      //     type: 'object',
      //     label: 'Email',
      //     name: 'user',
      //     children: 'email',
      // },
      {
        label: "Reason",
        name: "reason",
      },
      {
        label: "Content",
        name: "content",
      },
    ];
  }, []);

  const { Link } = RouterProvider;  

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <Form {...formProps} layout="vertical">
        {formItems.map(({ label, name, type, children }, index) => (
          <Form.Item label={label} name={name} key={index}>
            {label === "User" ? (
              <Link
                target="_blank"
                to={`/users/edit/${record?.data?.user?._id}`}
              >
                {type === "object"
                  ? record?.data?.[name][children]
                  : record?.data[name]}
              </Link>
            ) : type === "object" ? (
              record?.data?.[name][children]
            ) : (
              record?.data[name]
            )}
          </Form.Item>
        ))}
        <Form.Item
          label="adminComment"
          name="adminComment"
          initialValue={record?.data.adminComment}
        >
          <textarea
            rows={4}
            style={{
              width: "100%",
              color: "#626262",
              border: "1px solid #d9d9d9",
              padding: "4px 12px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
        </Form.Item>
        <Form.Item
          label="Send AdminComment"
          name="checkSendAdminComment"
          initialValue={record?.data.checkSendAdminComment}
           valuePropName="checked"
        >
          <Checkbox
            defaultChecked={record?.data.checkSendAdminComment}
          >
            Send adminComment
          </Checkbox>
        </Form.Item>
        <Form.Item
          label="Status"
          name="status"
          initialValue={record?.data.status}
        >
          <Select
            style={{ width: "200px" }}
            defaultValue={{ value: "pending", label: "Pending" }}
            options={optionStatus}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
